import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
// import { Link } from 'react-router-dom';
import { Button, Checkbox } from 'flowbite-react';
import { displayDateOnly } from '../../Utils';
import { useState } from 'react';
import Loader from '../Common/Loader';
import { RequestQuoteForm } from '../../Models/RequestQuoteForm';
export default function RequestQuoteFormListTable({
  data,
}: {
  data: RequestQuoteForm[];
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const columnHelper = createColumnHelper<RequestQuoteForm>();

  const columns = [
    columnHelper.accessor((row) => row.companyName ?? '', {
      id: 'companyName',
      header: 'Dealer',
      cell: (info) => info.getValue() || <i className='text-gray-400'>Unknown</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.firstName, {
      id: 'firstName',
      header: 'First Name',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.lastName, {
      id: 'lastName',
      header: 'Last Name',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.email, {
      id: 'email',
      header: 'Email',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.phone, {
      id: 'phone',
      header: 'Phone',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
    columnHelper.accessor((row) => row.questionsComments, {
      id: 'questionsComments',
      header: 'Questions/Comments',
      footer: (info) => info.column.id,
      enableColumnFilter: true,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        {isLoading && <Loader />}
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
